import * as formUtil from '../../util/form-util';
import { IFormMetadataProcessor } from './iFormMetaDataProcessor';
import { FormData } from '../../forms-ui-form-faas.interface';

/*
 * Because defining many drowdown options in the faas ui is clunky, we've created a short
 * cut for the country field. Instead of requiring the user to add each country as an
 * option, they can just leave the options list empty and we'll populate the field for
 * them from a list of countries stored in a json file on the DAM
 */
export class CountryProcessor implements IFormMetadataProcessor {
	async process(formMetadata: FormData): Promise<FormData> {
		await Promise.all(formMetadata.formFields.map(async (field) => {
			if (field.dataElement === 'country' && field.control === 'Dropdown') {
				field.dataSets = await formUtil.loadCountries();
			}
		}));
		return formMetadata;
	}
}
